function throwError(errorMessage) {
	throw new Error(errorMessage);
}

module.exports = throwError;